import { preventImplicitSubmit } from "../../../../../app/javascript/keyboard/form_keys"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "itemTemplate", "itemsContainer", "itemsPanel"]
    static values = { itemVariantsUrl: String }

    connect() {
        this.itemVariants = []
        this.variantOptionContent = null
        this.itemContent = this.itemTemplateTarget.innerHTML

        this.formTarget.addEventListener("keydown", preventImplicitSubmit)


        setTimeout(() => {
            this.clientInput = this.formTarget.querySelector("input[name='favorite_order[client_id]']")
            this.selectedClientId = this.clientInput?.value || ""
            this.clientSelectInput = this.formTarget.querySelector("input[id='favorite_order_client_id_hw_combobox']")
            this.itemsContainerTarget.querySelectorAll("li.item-container").forEach(item => this.configureVariantPicker(item))
            this.clientSelectInput?.focus()
        }, 10)
    }

    addItem(event) {
        if (event) event.preventDefault()
        const content = this.itemContent.replace(/NEW_RECORD/g, new Date().getTime())
        this.itemsContainerTarget.insertAdjacentHTML("beforeend", content)
        const lastItem = this.itemsContainerTarget.querySelector("li.item-container:last-child")
        this.configureVariantPicker(lastItem)
        const firstInput = lastItem.querySelector("input")
        firstInput.focus()
    }

    removeItem(event) {
        event.preventDefault()
        const wrapper = event.target.closest(".item-container")
        wrapper.remove()
    }

    clearItems() {
        this.itemsContainerTarget.innerHTML = ""
    }

    configureVariantPicker(item) {
        const fieldset = item.querySelector("[data-hw-combobox-async-src-value]")
        if (fieldset) fieldset.dataset.hwComboboxAsyncSrcValue = `${this.itemVariantsUrlValue}?client_id=${encodeURIComponent(this.clientInput?.value || "CLIENT_ID")}`
    }

    changeClient(event) {
        if (event) event.preventDefault()

        const clientId = this.clientInput?.value || ""
        if (clientId === this.selectedClientId) return
        this.selectedClientId = clientId
        this.clearItems()
        this.itemsPanelTarget.classList.toggle("d-none", !this.clientIdPresent())
        if (this.clientIdPresent()) this.addItem()
    }

    clientIdPresent() {
        return Boolean(this.clientInput?.value)
    }

    selectVariant(event) {
        if (event) event.preventDefault()
        const item = event.target.closest("li.item-container")
        if (item.querySelector("input[name$='[item_variant_id]']")?.value && item.parentElement.lastElementChild === item) this.addItem()
    }

}
